import { Outlet } from "react-router-dom";
import PublicNav from "./PublicNav";
import Footer from "./Footer";

export default function PublicLayout() {
  return (
    <div className="grain min-h-screen bg-void">
      <PublicNav />
      <main><Outlet /></main>
      <Footer />
    </div>
  );
}
